import {writable} from "svelte/store";

// drag and drop store
export const dndStore = writable (null);
